<template>
  <div class="slot__wrapper">
    <Affix v-if="prefix" v-bind="prefix" />

    <slot />

    <Affix v-if="suffix" v-bind="suffix" />
  </div>
</template>

<script>
import Affix from '@/lego/components/appends/Affix.vue';

export default {
  components: {
    Affix,
  },
  props: {
    prefix: {
      type: Object|Array,
      default: null,
    },
    suffix: {
      type: Object|Array,
      default: null,
    },
  },
};
</script>

<style lang="postcss" scoped>
.slot {
  &__wrapper {
    @apply flex items-center gap-quark w-full;
  }
}
</style>
